<div [class]="skinName">
  <div class="section">
    <header class="index-head">{{ headText }}</header>
    <div class="sub-title-head">{{ subHeadText }}</div>
    @if(telcoContries?.length>1){
      <div class="operators-drop-down">
        <div class="operator-drop">
          <li id="dropdown" class="dropdown">
            <a class="dropdown-toggle cursor-pointer" id = "dropdownMenuButton" data-toggle="dropdown"  aria-expanded = "false">
              <span class="opert">{{selectedOperator}}</span>
              @if (telcoContries?.length>1) {
                <span id="arrow-img"></span>
              }
            </a>
            <ul class="dropdown-menu dropdown-menu-bottom" aria-labelledby= "dropdownMenuButton">
              @for (region of telcoContries ; track region; let i = $index) {
                <li>
                  <div class="operators-list" (click)="operatorChange(region)">
                    <span>{{(configService.localeKeys[region.country_name]) ? configService.localeKeys[region.country_name] : region.country_name}}</span>
                  </div>
                </li>
              }
            </ul>
          </li>
        </div>
      </div>
    }
    <div class="operators">
      <!-- Telco Operator Login -->
      <!-- <div class="operator" (click)="operatorRedirect(operator)" *ngFor="let operator of operators; let i = index"> -->
      @if (settingsService.ezproxyEnabled) {
        <div class="operator" (click)="eazyProxyLogin()">
          <div class="operator-logo-box"><img src="branding/theme/assets/static_assets/ic-ezy-proxy-logo.svg" alt="ez proxy"></div>
          <span [title]="configService.localeKeys?.library_login_btn_title">{{configService.localeKeys?.library_login_btn_title || 'Log in via de Bibliotheek'}}</span>
        </div>
      }
      @for (operator of operators; track operator; let i = $index) {
        <div class="operator" [routerLink]="['/index/operators', operator.slug]">
          <div class="operator-logo-box"><img [src]="settingsService.getImage(operator?.telco_logo, 'logo')" alt=""></div>
          <span [title]="operator.name">{{ operator.name }}</span>
        </div>
      }
    </div>
  </div>
</div>